let cache = null;

const LINE_RE = /^"([^"]+)"\s*:\s*"(.*)$/;

function parseLooseRecordLine(line) {
  const m = line.match(LINE_RE);
  if (!m) {
    return null;
  }

  const key = m[1];
  let value = m[2];

  if (value.endsWith(',')) {
    value = value.slice(0, -1);
  }
  if (value.endsWith('"')) {
    value = value.slice(0, -1);
  }

  return { key, value };
}

function parseLooseCharacterData(text) {
  const lines = text.split(/\r?\n/);
  const records = [];
  let current = null;

  for (const rawLine of lines) {
    const line = rawLine.trim();

    if (line === '{') {
      current = {};
      continue;
    }

    if (line === '},' || line === '}') {
      if (current && current.id) {
        records.push(current);
      }
      current = null;
      continue;
    }

    if (!current) {
      continue;
    }

    const parsed = parseLooseRecordLine(line);
    if (parsed) {
      current[parsed.key] = parsed.value;
    }
  }

  return records;
}

function normalizeCharacter(record) {
  return {
    id: String(record.id || ''),
    implementation_date: record.implementation_date || '',
    name: record.name || '',
    title: record.title || '',
    role: record.role || '',
    element: record.element || '',
    race: record.race || '',
    affiliation: record.affiliation || '',
    s1: record.s1 || '',
    s2: record.s2 || '',
    s1_plus: record.s1_plus || '',
    s2_plus: record.s2_plus || '',
    accessory_name: record.accessory_name || '',
    accessory_effect: record.accessory_effect || '',
    unique_ability: record.unique_ability || '',
    unique_skill: record.unique_skill || '',
  };
}

export async function loadCharacterData() {
  if (cache) {
    return cache;
  }

  const response = await fetch('/data/charadata.txt', { cache: 'no-store' });
  if (!response.ok) {
    throw new Error('Failed to load character data.');
  }

  const text = await response.text();
  const parsed = parseLooseCharacterData(text).map(normalizeCharacter);

  cache = parsed;
  return parsed;
}

export function sanitizeDisplayText(value) {
  if (!value) {
    return '';
  }

  return String(value)
    .replace(/\\r\\n/g, '\n')
    .replace(/\\n/g, '\n')
    .replace(/&color\([^)]*\)\{([^}]*)\};?/g, '$1')
    .replace(/&tooltip\(([^)]*)\)\{([^}]*)\};?/g, '$2')
    .replace(/&tooltip\(([^)]*)\);?/g, '$1')
    .replace(/&nobold\{([^}]*)\};?/g, '$1')
    .replace(/&null\{[^}]*\};?/g, '')
    .replace(/&br;/g, '\n')
    .replace(/&color\([^)]*\)\{/g, '')
    .replace(/&tooltip\([^)]*\)\{/g, '')
    .replace(/&nobold\{/g, '')
    .replace(/\}\s*;?\s*$/gm, '')
    .replace(/[ \t]+\n/g, '\n')
    .trim();
}

export function splitLines(value) {
  const sanitized = sanitizeDisplayText(value);
  if (!sanitized) {
    return [];
  }

  return sanitized
    .split(/\r?\n|・・/u)
    .map((line) => line.trim())
    .filter(Boolean);
}
